import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ThemeContract {
  key: string;
  displayName: string;
  version: string;
  direction: 'rtl' | 'ltr';
  cssVariables: Record<string, string>;
}

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly themeState = signal<ThemeContract | null>(null);
  readonly theme = this.themeState.asReadonly();

  constructor(private readonly http: HttpClient) {}

  loadTheme(): Observable<ThemeContract> {
    return this.http
      .get<ThemeContract>(`${environment.apiBaseUrl}/api/v1/platform/theme/current`)
      .pipe(tap(theme => this.applyTheme(theme)));
  }

  applyTheme(theme: ThemeContract): void {
    this.themeState.set(theme);
    document.documentElement.dir = theme.direction;
    document.documentElement.dataset['themeKey'] = theme.key;
    document.documentElement.dataset['themeVersion'] = theme.version;
    for (const [name, value] of Object.entries(theme.cssVariables)) {
      document.documentElement.style.setProperty(name, value);
    }
  }
}
